<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> created a chatbot named-->
<!--        <strong>{{ $_.get(activity, "payload.title") }}</strong>.-->
        <span v-html="$t('notification.chatbotCreated', {user: $_.get(activity, 'actorUser.name'), chatbot: $_.get(activity, 'payload.title') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatbotCreated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
